var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main scroll" },
    [
      _c("div", { attrs: { slot: "top" }, slot: "top" }, [
        _c("p", { staticClass: "report-title" }, [
          _vm._v(
            "\n      衡水市" +
              _vm._s(_vm.dimension.stageName) +
              "学生综合素质评价学期报告\n    "
          )
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _c("page-template", {
        attrs: { "card-list": _vm.cards, "title-show": false }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "report-title-sub" }, [
      _c("span", [_vm._v("学校："), _c("span", { staticClass: "info-text" })]),
      _vm._v(" "),
      _c("span", [_vm._v("班级： "), _c("span", { staticClass: "info-text" })]),
      _vm._v(" "),
      _c("span", [
        _vm._v("第"),
        _c("span", { staticClass: "info-text" }),
        _vm._v("学期")
      ]),
      _vm._v(" "),
      _c("span", [_c("span", { staticClass: "info-text" }), _vm._v("学年")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2a681582", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2a681582","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/student-status-card/QualityEvaluationTermReportStatic.vue
// module id = null
// module chunks = 